module.exports = __webpack_public_path__ + "static/Ethical-Hacker-5d282ac197c5499fc22ab25531b17ff2.png";